// assets
import CloudUploadOutlined from '@ant-design/icons/CloudUploadOutlined';
import CreditCardOutlined from '@ant-design/icons/CreditCardOutlined';
import InteractionOutlined from '@ant-design/icons/InteractionOutlined';
import MenuOutlined from '@ant-design/icons/MenuOutlined';
import ProfileOutlined from '@ant-design/icons/ProfileOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';

// type
import { NavItemType } from 'types/menu';

const icons = {
  CloudUploadOutlined,
  CreditCardOutlined,
  InteractionOutlined,
  MenuOutlined,
  ProfileOutlined,
  SettingOutlined,
  UserOutlined
};

// ==============================|| MENU ITEMS - ADMINISTRATION ||============================== //

const administration: NavItemType = {
  id: 'group-pages',
  title: 'Administration',
  type: 'group',
  children: [
    {
      id: 'administration-menu',
      title: 'Administration',
      type: 'collapse',
      icon: icons.ProfileOutlined,
      children: [
        {
          id: 'client-profile',
          title: 'Client Profile',
          type: 'collapse',
          icon: icons.UserOutlined,
          children: [
            {
              id: 'account-profile',
              title: 'Account Profile',
              type: 'item',
              url: '/profiles/account/basic',
              disabled: false
            }
          ]
        },
        {
          id: 'upload-center',
          title: 'Upload Center',
          type: 'item',
          icon: icons.CloudUploadOutlined,
          url: '/upload-center',
          disabled: false
        },
        {
          id: 'inventory-management',
          title: 'Inventory Management',
          type: 'collapse',
          icon: icons.CreditCardOutlined,
          children: [
            {
              id: 'asset-inventory-table',
              title: 'Asset Inventory',
              type: 'item',
              url: '/asset-inventory-table',
              disabled: false
            },
            {
              id: 'data-management',
              title: 'Data Management',
              type: 'item',
              url: '/data-management',
              disabled: false
            },
            {
              id: 'non-asset-data',
              title: 'Non-asset Data',
              type: 'item',
              url: '/non-asset-data',
              disabled: false
            },
            {
              id: 'spatial-intelligence',
              title: 'Spatial Intelligence',
              type: 'item',
              url: '/spatial-intelligence',
              disabled: false
            },
            {
              id: 'add-new-asset',
              title: 'Add New Asset',
              type: 'item',
              url: '/add-new-asset',
              disabled: false
            }
          ]
        },
        {
          id: 'integration-center',
          title: 'Integration Center',
          type: 'item',
          url: '/integration-center',
          icon: icons.InteractionOutlined,
          disabled: false
        },
        {
          id: 'preferences',
          title: 'Preferences',
          type: 'collapse',
          icon: icons.SettingOutlined,
          children: [
            {
              id: 'asset-hierarchy',
              title: 'Asset Hierarchy',
              type: 'item',
              url: '/asset-hierarchy',
              disabled: false
            },
            {
              id: 'standard-fields',
              title: 'Standard Fields',
              type: 'item',
              url: '/standard-fields',
              disabled: false
            },
            {
              id: 'visual-preferences',
              title: 'Visual Preferences',
              type: 'item',
              url: '/visual-preferences',
              disabled: false
            },
            {
              id: 'backup-settings',
              title: 'Backup Settings',
              type: 'item',
              url: '/backup-settings',
              disabled: false
            },
            {
              id: 'risk-setting',
              title: 'Risk Setting',
              type: 'item',
              url: '/risk-setting',
              disabled: false
            },
            {
              id: 'access-control',
              title: 'Access Control',
              type: 'item',
              url: '/access-control',
              disabled: false
            },
            {
              id: 'standard-treatment',
              title: 'Standard Treatment',
              type: 'item',
              url: '/Standard-treatment',
              disabled: false
            },
            {
              id: 'level-of-service-setting',
              title: 'Level of Service Setting',
              type: 'item',
              url: '/level-of-service-setting',
              disabled: false
            },
            {
              id: 'asset-hierarchy-builder',
              title: 'Asset Hierarchy Builder',
              type: 'item',
              url: '/Feature-Two-Preferences',
              disabled: false
            },
            {
              id: 'general-setting',
              title: 'General Setting',
              type: 'item',
              url: '/general-setting',
              disabled: false
            },
            {
              id: 'asset-valuation-setting',
              title: 'Asset Valuation Setting',
              type: 'item',
              url: '/asset-valuation-setting',
              disabled: false
            },
            {
              id: 'deterioration-models',
              title: 'Deterioration Models',
              type: 'item',
              url: '/deterioration-models',
              disabled: false
            },
            {
              id: 'menu-customization',
              title: 'Menu Customization',
              type: 'item',
              url: '/menu-customization',
              disabled: false
            }
          ]
        }
        // {
        //   id: 'extra-features',
        //   title: 'Extra Features',
        //   type: 'collapse',
        //   icon: icons.MenuOutlined,
        //   children: [
        //     {
        //       id: 'asset-detection',
        //       title: 'Asset Detection',
        //       type: 'item',
        //       url: '/asset-detection',
        //       disabled: true
        //     },
        //     {
        //       id: 'asset-detection-2',
        //       title: 'Asset Detection 2',
        //       type: 'item',
        //       url: '/asset-detection-2',
        //       disabled: true
        //     },
        //     {
        //       id: 'asset-importer',
        //       title: 'Asset Importer',
        //       type: 'item',
        //       url: '/asset-importer',
        //       disabled: true
        //     },
        //     {
        //       id: 'building-modelling',
        //       title: 'Building Modelling',
        //       type: 'item',
        //       url: '/building-modelling',
        //       disabled: true
        //     }
        //   ]
        // }
      ]
    }
  ]
};

export default administration;
